<template>
  <div>
    <div class="newsheader-contain">
      <div class="location-contain">
        您的位置：
        <router-link tag="a" to="/Home" class="home-title">首页</router-link
        ><i class="fa fa-angle-right" aria-hidden="true"></i
        ><router-link tag="a" to="/News" class="home-title"
          >新闻中心</router-link
        ><i class="fa fa-angle-right" aria-hidden="true"></i
        ><router-link tag="a" to="/News/2" class="news-name"
          >公司新闻</router-link
        >
      </div>
    </div>
    <div class="news-contain">
      <div class="news-chunk">
        <div class="news-left">
          <h1 class="news-title">如何使医疗设备发挥出最佳的功能日益重要</h1>
          <div class="news-date">
            2021年03月15日 05:26<span>媒体来源：网络</span>
          </div>
          <div class="news-side">
            医疗设备是医院的物质基础，是现代化程度的重要标志，在医疗诊断过程中发挥着举足轻重的作用。如何使医疗设备发挥出最佳的功能日益重要。作为医学工程的主体-医学工程人员，如何最大限度的发挥自己的主观能动性，用创造性的思维去管理维护医疗设备是新时期医学工程技术人员面临的一项重要课题。
          </div>
          <div class="news-text1">
            近年来，各种各样的新型医疗器械不断涌现，很多医院医学仪器设备总值已经占到医院固定资产的50%以上。而要使这些医疗仪器用得规范、用得高效，就离不开医学工程人员。在现代医院里，医生用着那么多不同作用的高科技医疗仪器设备，如果没有一支经验丰富的临床医学工程师队伍帮助进行临床仪器设备的维护和监控，不仅会直接影响诊疗效果，还可能波及医务人员和患者的生命安全。随着高科技越来越多的被应用到医疗设备上来，对医学工程人员的要求越来越高，但医学工程人员水平的发展却受到诸多因素制约。
          </div>
          <div class="new-images">
            <img
              src="../../../static/images/news7.png"
              alt="如何使医疗设备发挥出最佳的功能日益重要"
            />
          </div>
          <div class="news-text2">
            （1）医疗设备种类繁多，工程师不能逐一明了仪器的原理，只能处理中小故障，对一些复杂问题不能解决；
          </div>
          <div class="news-text2">
            （2）尤其是常规大型和大型医疗设备，厂方对一些关键技术数据保密，使工程师难以深入下去；
          </div>
          <div class="news-text2">
            （3）医疗设备发展迅速猛，运用到医疗设备上的科技含量越来越高，知识越来越全面，光学，电子，机械，计算机等各方面知识都结合在一起，工程师仅靠自己以前掌握的知识，不再抓紧时间为自己充电是跟不上时代发展的；
          </div>
          <div class="news-text2">
            （4）长期以来，医院普遍重医轻工，忽视工程师的业务发展，很少提供外出进修学习机会。鉴于以上原因，工程技术人员的业务水平远远落后于医学工程的发展。
          </div>
          <div class="news-text2">
            在一座现代化的医院，医疗手段在很大程度上要依赖医疗设备，很大程度上要靠工程师的日常保养与快速准确的检修。因此，医学工程技术人员的技能培训显得尤为重要。
          </div>
          <div class="news-text2">
            （1）加强了对工程技术人员的重视，提高了他们的地位，让他们认识到自己的价值，努力钻研业务。定期选派工程技术人员参加医疗设备维修培训；
          </div>
          <div class="news-text2">
            （2）各有专长，让每个学有所长，术有专攻。医疗设备涉及的范围很广，要求工程师无论哪一台设备都精通是很不现实的，通过外出培训学习某一方面的仪器，并在院内按所学分工维修管理仪器、设备，在平时实践中搞通搞懂，成为某一方面的专；
          </div>
          <div class="news-text2">
            （3）在购入新设备时，要求厂方对工程师进行设备培训，让工程师基本上掌握设备的工作原因和常见故障处理。在厂方安装设备时，工程师都全程陪同，详细了解设备的的性能指标，并能进行简单操作；
          </div>
          <div class="news-text2">
            （4）要求工程师平时加强自身学习，在工作中总结经验，提高自己分析问题和解决问题的能力，掌握更新的维修技术。并能撰写出专业技术论文。
          </div>
          <div class="news-text2">
            医学工程技术人员在对医疗设备的引进、安装、调试维护保障方面起到很大作用，工程技术人员充分发挥自己的主观能动性与临床医生紧密配合开发设备的功能，让医疗设备发挥出应有的效益。经过良好培训并掌握技能的医学工程技术人员一定会极大地促进医院的发展。
          </div>
          <div class="news-bottom">
            <div class="roll-left" @click="leftClick">
              <i class="fa fa-angle-left" aria-hidden="true"></i>
            </div>
            <div class="content-left">
              <transition name="left1" mode="out-in">
                <router-link
                  tag="a"
                  :to="bannerData[banneroneIndex].url"
                  class="transition-text"
                  v-if="bannerData[banneroneIndex].url == '/News/1'"
                >
                  {{ bannerData[banneroneIndex].name }}
                </router-link>
              </transition>
              <transition name="left3" mode="out-in">
                <router-link
                  tag="a"
                  :to="bannerData[banneroneIndex].url"
                  class="transition-text"
                  v-if="bannerData[banneroneIndex].url == '/News/3'"
                >
                  {{ bannerData[banneroneIndex].name }}
                </router-link>
              </transition>
              <transition name="left4" mode="out-in">
                <router-link
                  tag="a"
                  :to="bannerData[banneroneIndex].url"
                  class="transition-text"
                  v-if="bannerData[banneroneIndex].url == '/News/4'"
                >
                  {{ bannerData[banneroneIndex].name }}
                </router-link>
              </transition>
              <transition name="left5" mode="out-in">
                <router-link
                  tag="a"
                  :to="bannerData[banneroneIndex].url"
                  class="transition-text"
                  v-if="bannerData[banneroneIndex].url == '/News/5'"
                >
                  {{ bannerData[banneroneIndex].name }}
                </router-link>
              </transition>
              <transition name="left6" mode="out-in">
                <router-link
                  tag="a"
                  :to="bannerData[banneroneIndex].url"
                  class="transition-text"
                  v-if="bannerData[banneroneIndex].url == '/News/6'"
                >
                  {{ bannerData[banneroneIndex].name }}
                </router-link>
              </transition>
            </div>
            <div class="content-right">
              <transition name="right1" mode="out-in">
                <router-link
                  tag="a"
                  :to="bannerData[banneronetwoIndex].url"
                  class="transition-text"
                  v-if="bannerData[banneronetwoIndex].url == '/News/1'"
                >
                  {{ bannerData[banneronetwoIndex].name }}
                </router-link>
              </transition>
              <transition name="right3" mode="out-in">
                <router-link
                  tag="a"
                  :to="bannerData[banneronetwoIndex].url"
                  class="transition-text"
                  v-if="bannerData[banneronetwoIndex].url == '/News/3'"
                >
                  {{ bannerData[banneronetwoIndex].name }}
                </router-link>
              </transition>
              <transition name="right4" mode="out-in">
                <router-link
                  tag="a"
                  :to="bannerData[banneronetwoIndex].url"
                  class="transition-text"
                  v-if="bannerData[banneronetwoIndex].url == '/News/4'"
                >
                  {{ bannerData[banneronetwoIndex].name }}
                </router-link>
              </transition>
              <transition name="right5" mode="out-in">
                <router-link
                  tag="a"
                  :to="bannerData[banneronetwoIndex].url"
                  class="transition-text"
                  v-if="bannerData[banneronetwoIndex].url == '/News/5'"
                >
                  {{ bannerData[banneronetwoIndex].name }}
                </router-link>
              </transition>
              <transition name="right6" mode="out-in">
                <router-link
                  tag="a"
                  :to="bannerData[banneronetwoIndex].url"
                  class="transition-text"
                  v-if="bannerData[banneronetwoIndex].url == '/News/6'"
                >
                  {{ bannerData[banneronetwoIndex].name }}
                </router-link>
              </transition>
            </div>
            <div class="roll-right" @click="rightClick">
              <i class="fa fa-angle-right" aria-hidden="true"></i>
            </div>
          </div>
        </div>
        <div class="news-right">
          <div class="relevant-content">相关内容</div>
          <div class="relatedcontent">
            <router-link
              tag="a"
              :to="item.url"
              class="relatedtab"
              v-for="(item, index) in tabData"
              :key="index"
            >
              {{ item.name }}
            </router-link>
          </div>
          <div class="underline"></div>
          <router-link tag="a" to="/News/6">
            <div class="journalism-title">
              前海高扬联合创办并授牌100个中心...
            </div>
            <div class="journalism-name">
              2021年4月10日，在第十一届中国医疗设备行业数据发布大会上，《中国医疗设备》杂志社作为创始人...
            </div>
          </router-link>
          <div class="underline"></div>
          <router-link tag="a" to="/News/1">
            <div class="journalism-title">2020年为什么这么多医疗器械...</div>
            <div class="journalism-name">
              年后医疗器械招聘猛增，尤其是医疗器械维修工程师岗位，我所在的X射线细分领域来说，具体有...
            </div>
          </router-link>
          <div class="underline"></div>
          <router-link tag="a" to="/News/3">
            <div class="journalism-title">
              医疗器械行业趋势及设备维修技术探讨
            </div>
            <div class="journalism-name">
              根据医疗器械相关法规，医疗器械使用单位对需要定期检查、检验、校准、保养、维护的医疗....
            </div>
          </router-link>
          <div class="underline"></div>
          <router-link tag="a" to="/News/4">
            <div class="journalism-title">
              医疗器械的售后维修服务正逐渐成为...
            </div>
            <div class="journalism-name">
              随着近年来医疗器械产品与信息技术的不断升级，第三方医疗器械维修公司也纷纷依托大数据...
            </div>
          </router-link>
          <div class="underline"></div>
          <router-link tag="a" to="/News/5">
            <div class="journalism-title">医疗设备日常巡检保养的重要性</div>
            <div class="journalism-name">
              当前医院医疗设备故障很大一部分是由于巡检保养没有到位的原因引起的，完善医疗设备巡检...
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import bottom from "@/components/bottom";
export default {
  components: {
    bottom
  },
  data() {
    return {
      tabData: [
        { name: "全部", url: "/news" },
        { name: "医疗资讯", url: "/news?type=医疗资讯" },
        { name: "培训中心", url: "/news?type=培训中心" }
      ],
      bannerData: [
        {
          name: "前海高扬联合创办并授牌100个中心城市的线下实体...",
          url: "/News/6"
        },
        {
          name: "2020年为什么这么多医疗器械公司一直招人",
          url: "/News/1"
        },
        { name: "医疗器械行业趋势及设备维修技术探讨", url: "/News/3" },
        {
          name: "医疗器械的售后维修服务正逐渐成为下一个风口",
          url: "/News/4"
        },
        { name: "医疗设备日常巡检保养的重要性", url: "/News/5" }
      ],
      banneroneIndex: 0,
      banneronetwoIndex: 1
    };
  },
  methods: {
    leftClick() {
      if (this.banneroneIndex == 0) {
        this.banneroneIndex = 3;
        this.banneronetwoIndex = 4;
      } else if (this.banneroneIndex == 1) {
        this.banneroneIndex = 4;
        this.banneronetwoIndex = 0;
      } else if (this.banneroneIndex == 2) {
        this.banneroneIndex = 0;
        this.banneronetwoIndex = 1;
      } else if (this.banneroneIndex == 3) {
        this.banneroneIndex = 1;
        this.banneronetwoIndex = 2;
      } else if (this.banneroneIndex == 4) {
        this.banneroneIndex = 2;
        this.banneronetwoIndex = 3;
      }
    },
    rightClick() {
      if (this.banneroneIndex == 0) {
        this.banneroneIndex = 2;
        this.banneronetwoIndex = 3;
      } else if (this.banneroneIndex == 1) {
        this.banneroneIndex = 3;
        this.banneronetwoIndex = 4;
      } else if (this.banneroneIndex == 2) {
        this.banneroneIndex = 4;
        this.banneronetwoIndex = 0;
      } else if (this.banneroneIndex == 3) {
        this.banneroneIndex = 0;
        this.banneronetwoIndex = 1;
      } else if (this.banneroneIndex == 4) {
        this.banneroneIndex = 1;
        this.banneronetwoIndex = 2;
      }
    }
  }
};
</script>

<style scoped lang="less">
.newsheader-contain {
  width: 100%;
  height: 48px;
  background: #f8f8f8;
  .location-contain {
    width: 1170px;
    height: 48px;
    margin: 0 auto;
    line-height: 56px;
    color: #666666;
    font-size: 12px;
    .fa-angle-right {
      margin: 0 5px;
    }
    .home-title {
      cursor: pointer;
      color: #666666;
      &:hover {
        color: #3488ea;
      }
    }
    .news-name {
      cursor: pointer;
      color: #3488ea;
    }
  }
}
.news-contain {
  width: 1170px;
  margin: 0 auto;
  padding: 40px 0 50px 0;
  .news-chunk {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .news-left {
      width: 68%;
      .news-title {
        color: #444444;
        font-size: 18px;
        line-height: 10px;
        font-weight: 500;
      }
      .news-date {
        color: #999999;
        font-size: 12px;
        margin-top: 8px;
        span {
          margin-left: 20px;
        }
      }
      .news-side {
        width: 100%;
        padding: 40px 0;
        color: #666666;
        font-size: 14px;
        font-weight: 300;
        line-height: 24px;
        border-bottom: 1px solid #e5e5e5;
      }
      .news-text1 {
        color: #666666;
        font-size: 14px;
        font-weight: 300;
        line-height: 24px;
        margin-top: 20px;
      }
      .news-text2 {
        margin-top: 25px;
        color: #666666;
        font-size: 14px;
        font-weight: 300;
        line-height: 24px;
      }
      .new-images {
        width: 100%;
        margin-top: 20px;
        img {
          width: 100%;
          height: 280px;
          display: block;
        }
      }
      .news-bottom {
        width: 100%;
        height: 120px;
        background: #f9f9f9;
        display: flex;
        flex-direction: row;
        margin-top: 50px;

        .fa {
          color: #b7b7b7;
          font-size: 20px;
        }
        .roll-left {
          width: 8%;
          height: 120px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          transition: all 0.5s;
          .fa-angle-left {
            transition: all 0.5s;
          }
        }
        .roll-left:hover {
          background: #3488ea;
          transition: all 0.5s;
          .fa-angle-left {
            color: #ffffff;
            transition: all 0.5s;
          }
        }
        .content-left {
          width: 42%;
          height: 120px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #666666;
          font-size: 12px;
          font-weight: 400;
          .transition-text {
            color: #666666;
            cursor: pointer;
            overflow-y: auto;
            overflow-x: hidden;
            position: absolute;
            &:hover {
              color: #3488ea;
            }
          }
        }
        .content-right {
          width: 42%;
          height: 120px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #666666;
          font-size: 12px;
          font-weight: 400;
          .transition-text {
            color: #666666;
            cursor: pointer;
            overflow-y: auto;
            overflow-x: hidden;
            position: absolute;
            &:hover {
              color: #3488ea;
            }
          }
        }
        .roll-right {
          width: 8%;
          height: 120px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          transition: all 0.5s;
          .fa-angle-right {
            transition: all 0.5s;
          }
        }
        .roll-right:hover {
          background: #3488ea;
          transition: all 0.5s;
          .fa-angle-right {
            color: #fff;
            transition: all 0.5s;
          }
        }
      }
    }
    .news-right {
      width: 28%;
      .relevant-content {
        color: #666666;
        font-size: 16px;
        font-weight: 300;
        line-height: 24px;
      }
      .relatedcontent {
        width: 90%;
        height: 85px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        .relatedtab {
          width: 30%;
          height: 28px;
          border: 1px solid #e5e5e5;
          text-align: center;
          line-height: 28px;
          color: #666666;
          font-size: 12px;
          cursor: pointer;
        }
        .relatedtab:hover {
          background: #3488ea;
          border: 1px solid #3488ea;
          color: #ffffff;
        }
      }
      .underline {
        width: 100%;
        height: 1px;
        background: #e5e5e5;
      }
      .journalism-title {
        color: #444444;
        font-size: 18px;
        font-weight: 300;
        margin-top: 20px;
        cursor: pointer;
        &:hover {
          color: #3488ea;
        }
      }
      .journalism-name {
        color: #666666;
        font-size: 14px;
        font-weight: 300;
        margin-top: 20px;
        line-height: 24px;
        margin-bottom: 20px;
        cursor: pointer;
      }
    }
  }
}

.left1-enter,
.right1-enter {
  opacity: 1;
}
.left3-enter,
.right3-enter {
  opacity: 1;
}
.left4-enter,
.right4-enter {
  opacity: 1;
}
.left5-enter,
.right5-enter {
  opacity: 1;
}
.left6-enter,
.right6-enter {
  opacity: 1;
}
.left1-enter-active,
.left1-leave-active,
.right1-enter-active,
.right1-leave-active {
  transition: all 1s;
}
.left3-enter-active,
.left3-leave-active,
.right3-enter-active,
.right3-leave-active {
  transition: all 1s;
}
.left4-enter-active,
.left4-leave-active,
.right4-enter-active,
.right4-leave-active {
  transition: all 1s;
}
.left5-enter-active,
.left5-leave-active,
.right5-enter-active,
.right5-leave-active {
  transition: all 1s;
}
.left6-enter-active,
.left6-leave-active,
.right6-enter-active,
.right6-leave-active {
  transition: all 1s;
}

.left1-enter,
.left1-leave-to,
.right1-enter,
.right1-leave-to {
  opacity: 0;
  transform: translateY(30px);
  position: absolute;
}
.left3-enter,
.left3-leave-to,
.right3-enter,
.right3-leave-to {
  opacity: 0;
  transform: translateY(30px);
  position: absolute;
}
.left4-enter,
.left4-leave-to,
.right4-enter,
.right4-leave-to {
  opacity: 0;
  transform: translateY(30px);
  position: absolute;
}
.left5-enter,
.left5-leave-to,
.right5-enter,
.right5-leave-to {
  opacity: 0;
  transform: translateY(30px);
  position: absolute;
}
.left6-enter,
.left6-leave-to,
.right6-enter,
.right6-leave-to {
  opacity: 0;
  transform: translateY(30px);
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/views/News/NewsDetails2.vue